import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Full-screen player for embed-mode content (iframe URL or raw HTML).
 */
export default function EmbedPlayer({ embedUrl, embedCode, title }) {
  const navigate = useNavigate();
  // Normalize backend-relative URLs
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const finalUrl = embedUrl && embedUrl.startsWith("/api/files/") ? `${BACKEND_URL}${embedUrl}` : embedUrl;

  return (
    <div className="fixed inset-0 bg-black flex flex-col" data-testid="embed-player">
      <div className="flex items-center gap-4 px-4 sm:px-6 py-4 bg-gradient-to-b from-black/95 to-transparent absolute top-0 left-0 right-0 z-10">
        <button onClick={() => navigate(-1)} className="text-white hover:text-[#E50914]" data-testid="embed-back-btn">
          <ArrowLeft size={28} />
        </button>
        <h2 className="text-lg sm:text-xl font-semibold text-white" style={{ fontFamily: "Outfit" }}>{title}</h2>
      </div>
      <div className="flex-1 w-full h-full">
        {embedCode ? (
          <div className="w-full h-full [&_iframe]:w-full [&_iframe]:h-full" dangerouslySetInnerHTML={{ __html: embedCode }} />
        ) : (
          <iframe
            src={finalUrl}
            className="w-full h-full border-0"
            allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
            allowFullScreen
            title={title}
            data-testid="embed-iframe"
          />
        )}
      </div>
    </div>
  );
}
